export class PlatformAccountBase {
  public username: string;
  public password: string;
}
